/**
 * 描述：左侧导航工具条
 * 日期：2017-9-20
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('leftToolTipModule', [])
    .directive('leftToolTip', ['$compile', '$timeout', function($compile, $timeout) {
        return {
            restrict: 'A',
            replace: false,
            template: '',
            transclude: false,
            scope: false,
            link: function(scope, $elem, $attrs) {
                var top, // 顶部距离
                    $template, // 模板
                    myTimeout, // 延时器
                    utilBtns; // 可见性
                scope.platform = $attrs['platform']; // 所属平台
                init();

                /**
                 * [init description] 初始化
                 * @return {[type]} [description]
                 */
                function init() {
                    bindMouseEnter();
                    bindMouseLeave();
                    initDestroy();
                }

                /**
                 * [initDestroy description] 初始化监听销毁事件
                 * @return {[type]} [description]
                 */
                function initDestroy() {
                    scope.$on('$destroy', function() {
                        $('.quickOperat_wrap').remove();
                    });
                }

                /**
                 * [initTemplate description] 初始化模板
                 * @return {[type]} [description]
                 */
                function initTemplate() {
                    return $(['<div class="quickOperat_wrap">',
                        '<div class="arrow"></div>',
                        '<span class="quickBtn">',
                        '<i class="iconfont icon-xianshi"  trs-Tooltip data-placement="auto top" data-container="body" title="预览" ng-click="websiteChannelPreview(node)"></i>',
                        '<i class="iconfont icon-fucengwenjianjia" trs-Tooltip data-placement="auto top" data-container="body" title="网盘" ng-click="websiteCloud(node,platform)"></i>',
                        '<i class="iconfont icon-suipian" trs-Tooltip data-placement="auto top" data-container="body" title="碎片化" ng-click="websiteFragment(node)"></i>',
                        '<i class="iconfont icon-gaojianshoucang" trs-Tooltip data-placement="auto top" data-container="body" title="收藏" ng-click="addToCommon(node)"></i>',
                        '</span>',
                        '</div>'
                    ].join(''));
                }

                /**
                 * [bindMouseEnter description] 绑定鼠标移入事件
                 * @return {[type]} [description]
                 */
                function bindMouseEnter() {
                    $elem.bind('mouseenter', function() {
                        $template = initTemplate();
                        $template.css({ 'top': $elem.offset().top - 2, display: 'block' });
                        utilBtns = scope.$parent.status.utilBtns ? scope.$parent.status.utilBtns : scope.$parent.status.app.utilBtns;
                        if (angular.isUndefined(utilBtns.FILE) || utilBtns.FILE.indexOf(scope.node.CHANNELID) < 0) {
                            $template.find('.icon-fucengwenjianjia').remove();
                        }
                        if (angular.isUndefined(utilBtns.PREVIEW) || utilBtns.PREVIEW.indexOf(scope.node.CHANNELID) < 0) {
                            $template.find('.icon-xianshi').remove();
                        }
                        if (angular.isUndefined(utilBtns.WIDGET) || utilBtns.WIDGET.indexOf(scope.node.CHANNELID) < 0 || scope.platform != 'signed') {
                            $template.find('.icon-suipian').remove();
                        }

                        showCollected(function(flag) {
                            if (!flag) {$template.find('.icon-gaojianshoucang').remove();}
                            $template.bind('mouseenter', function() {
                                clearTimeout(myTimeout);
                            });
                            $template.bind('mouseleave', function() {
                                $template.remove();
                                $('div[role="tooltip"]').remove();
                            });
                            $template.find('i').click(function() {
                                $("div[role='tooltip']").remove();
                                $template.remove();
                            });
                            if ($template.find('i').length == 0){
                                $template.find('.arrow').remove();
                            }
                            $template = $compile($template)(scope);
                            $('body').append($template);
                        });
                    });
                }

                /**
                 * [showCollected description] 是否显示收藏按钮
                 * @return {[type]} [description]
                 */
                function showCollected(success) {
                    $timeout(function() {
                        var flag = true;
                        var commonChannels = scope.$parent.status.commonChannels;
                        if (commonChannels.length >= 5 || commonChannels.flag == false) {
                            flag = false;
                        } else {
                            for (var i = 0; i < commonChannels.length; i++) {
                                if (scope.node.CHANNELID === commonChannels[i].CHANNELID) {
                                    flag = false;
                                    break;
                                }
                            }
                        }
                        success(flag);
                    });
                }

                /**
                 * [bindMouseLeave description] 绑定鼠标离开事件
                 * @return {[type]} [description]
                 */
                function bindMouseLeave() {
                    $elem.bind('mouseleave', function() {
                        myTimeout = setTimeout(function() {
                            $template.remove();
                        });
                    });
                }
            }
        };
    }]);
